// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"594":"d05edfef","604":"68a27d44","765":"a68293af","879":"28f42871"}[chunkId] + ".css";
};